(() => {
  'use strict';

  let frame = null;

  function syncCountdown() {
    frame = null;
    const source = document.querySelector('neat-announcement-urgency [data-countdown-output]');
    const sourceWrapper = source?.closest('[data-countdown]');
    const value = source?.textContent?.trim();
    const available = Boolean(source && sourceWrapper && value && value !== '00:00:00');

    document.querySelectorAll('[data-aminos-cart-urgency]').forEach((root) => {
      root.hidden = !available;
      if (!available) return;

      const output = root.querySelector('[data-aminos-cart-countdown-output]');
      if (output && output.textContent !== value) output.textContent = value;
    });
  }

  function scheduleSync() {
    if (frame) return;
    frame = window.requestAnimationFrame(syncCountdown);
  }

  const observer = new MutationObserver(scheduleSync);

  function start() {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleSync);
})();
